// /utils/orderSender.js

import axios from "axios";

/**
 * Send order to appropriate endpoint based on isVirtual flag.
 *
 * @param {Object} payload - Order payload.
 * @param {boolean} isVirtual - Whether the order is virtual.
 * @returns {Promise<Object>} API response or error object.
 */
const sendOrder = async (payload, isVirtual = false) => {
    // debugger;
    const url = isVirtual
        ? "https://hgb1gw5n6g.execute-api.ap-south-1.amazonaws.com/default/og_virtual_placeorder"
        : "https://0eo1dv23p5.execute-api.ap-south-1.amazonaws.com/default/og_allbrokers_placeorder";

    try {
        const response = await axios.post(url, payload);
        return response.data;
    } catch (error) {
        console.error("Error placing order:", error);
        return {
            status: false,
            message_header: "Error placing order",
            message_body: error.message,
        };
    }
};

export default sendOrder;
